import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type BlockGetListRequest = GetListRequest<BlockGetListRequestFilter>;
export type BlockGetListResponse = GetListResponse<Block>;
export type BlockDeleteRequest = DeleteRequest;

export interface BlockGetListRequestFilter {
  /** @format int64 */
  refVenueDetails_Id?: number;
  name?: string | null;
  description?: string | null;

  /** @format int64 */
  totalRows?: number;

  /** @format int64 */
  totalCols?: number;

  /** @format int64 */
  totalSeats?: number;
  gateNumber?: string | null;
  levelNumber?: string | null;
  rowLabelType?: BlockDetailsRowLabelType;
  columnLableType?: BlockDetailsColumnLabelType;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export type BlockDetailsRowLabelType = 1 | 2;
export type BlockDetailsColumnLabelType = 1 | 2;

export interface Block {
  /** @format int64 */
  refVenueDetails_Id: number;
  name: string;
  description?: string | null;

  /** @format int64 */
  totalRows: number;

  /** @format int64 */
  totalCols: number;

  /** @format int64 */
  totalSeats: number;
  gateNumber?: string | null;
  levelNumber?: string | null;
  blockLayoutType: string | null| number;
  rowLabelType?: BlockDetailsRowLabelType;
  columnLableType?: BlockDetailsColumnLabelType;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}
